import type { FC } from 'react'

import { cn } from '@/lib/utils'
import { HouseMark } from '@/components/generals/house-mark'

interface LogoProps {
    className?: string
}

/**
 * The Localboost lockup: the house mark plus the real wordmark, masked from the brand
 * file so it can take any text color while the house keeps its cyan.
 */
export const Logo: FC<LogoProps> = ({ className }) => {
    return (
        <span className={cn('inline-flex items-center gap-[0.26em] text-[22px]', className)}>
            <HouseMark className='h-[1.04em] w-[1.04em] shrink-0' />
            <span className='wordmark h-[1.04em] w-[4.76em]' />
        </span>
    )
}
